import type { RouteRecordRaw } from 'vue-router';

import Icons from '@/constants/Icons';
import RouteNames from '@/constants/RouteNames';
import type { AppRouteRecord } from '@/types/core';

export const hardwareListRoute: AppRouteRecord = {
  component: () => import('@/views/hardware/HardwareList.vue'),
  meta: {
    icon: Icons.Hardware,
  },
  name: RouteNames.Hardware.List,
  path: '',
};

export const hardwareRoutes: RouteRecordRaw = {
  children: [
    //
    hardwareListRoute,
  ],
  path: '/hardware',
};
